import { EpkModuleApiService } from '~packages/epk-front-shared/api-client';
import { Mode } from '~packages/json-api/client';

import getConstants from '@/constants';

const { isModeDevelopment } = getConstants();

const constructorParams = {
  className: 'OktmosApiService',
  mode: isModeDevelopment ? Mode.Production : Mode.Production,
  needInit: isModeDevelopment,
};

export default class OktmosApiService extends EpkModuleApiService {
  constructor() {
    super(constructorParams);
  }

  async hierarachial<T>(params) {
    const mask_current = params?.mask_current ?? true;
    const size = params?.size ?? 1e5;

    return await this._sendRequest(
      this.pathFetchAll + 'hierarachial/',
      { ...params, mask_current, size },
      { method: this.requestMethodFetchAll },
      { method: 'fetchAll' }
    );
  }
}
